export default __webpack_public_path__ + "static/media/rain_evening.7b7b9c9f.svg";